var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"},on:{"wheel":_vm.onWheel}},[_c('Header',{}),_c('Wrapper',{},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{staticClass:"view"})],1)],1),_c('Aside',{attrs:{"isScrolled":!_vm.isNewPage}}),_c('AsideSecond',{attrs:{"isScrolled":!_vm.isNewPage}}),_c('svg-sprite')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }